<template>
    <div>
        <mainheader></mainheader>
        <mainbox></mainbox>
        <section>
            <div class="container">
                <div class="article-container">
                    <div class="article-wrapper">
                        <span class="article-title">{{ translation.translate('thanks-page', 'title') }}</span>
                        <br>
                        <p class="article-text">{{ translation.translate('thanks-page', 'text-content') }} </p>
                        <div class="article-questions-btn-container">
                            <button class="article-questions-btn" @click="() => {this.$router.push({name:'LandingPage'})}" >{{ translation.translate('thanks-page', 'home-btn')
                            }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <mainfooter></mainfooter>
    </div>
</template>


<script>
import translate from '../../translation/translate'
import mainbox from "./mainbox.vue";
import mainheader from "./mainheader.vue";
import mainfooter from "./mainfooter.vue";

export default {
    name: 'article1',
    data() {
        return {
            translation: translate,

        }
    },
    components: {
        mainheader,
        mainbox,
        mainfooter
    },
  metaInfo() {
    return {
      title: "Спасибо за вашу заявку",
      meta: [
        {
          name: "description",
          content:
            "",
        },
      ],
    };
  },
}
</script>

<style scoped> 
.article-container {
    margin-top: 25px;
    text-align: center;
}
.article-questions-btn-container {
    margin-top: 45px;
}
</style>